import { AUCTION_BUYER, FACILITY_MANAGER, PRIVATE_SELLER} from 'helpers/users';

const userTypeUrlMap = {
    [FACILITY_MANAGER.id]: 'facility-manager',
    [AUCTION_BUYER.id]: 'auction-buyer',
    [PRIVATE_SELLER.id]: 'private-seller',
};

export default userTypeUrlMap;